// extracted by mini-css-extract-plugin
export default {"image":"SingleSelect_image__WX-yO","imageImg":"SingleSelect_imageImg__cx3bS","imagePh":"SingleSelect_imagePh__LE+Ol"};